import React from "react";
import PolicyLayout, { Section, Bullets } from "@/components/PolicyLayout";

export default function RefundPolicy() {
  return (
    <PolicyLayout title="Refund & Cancellation Policy" tagline="Legal · Refunds" updated="Feb 2026">
      <Section n={1} title="Order Cancellation">
        <p>
          Orders may be cancelled within <span className="text-white">2 hours of purchase</span> by
          emailing us at <a className="text-gold underline" href="mailto:support@teuralink.com">support@teuralink.com</a>,
          provided production has not commenced.
        </p>
        <p className="mt-2">
          Once personalization or printing has begun, cancellation requests cannot be accepted.
        </p>
      </Section>

      <Section n={2} title="Refund Eligibility">
        <p className="mb-2">Refunds may be approved only if:</p>
        <Bullets items={[
          "Incorrect product received",
          "Product damaged during transit",
          "Order cannot be fulfilled by Teuralink",
        ]} />
      </Section>

      <Section n={3} title="Non-Refundable Items">
        <p className="mb-2">The following are non-refundable:</p>
        <Bullets items={[
          "Personalized certificates",
          "Customized gift packages",
          "Products damaged due to customer misuse",
        ]} />
      </Section>

      <Section n={4} title="Damaged Products">
        <p>
          Please report damaged deliveries within <span className="text-white">48 hours of receipt</span> by
          emailing <a className="text-gold underline" href="mailto:support@teuralink.com">support@teuralink.com</a>.
        </p>
        <p className="mt-3 mb-2">Include:</p>
        <Bullets items={[
          "Order Number",
          "Photos of packaging",
          "Photos of the product",
        ]} />
      </Section>

      <Section n={5} title="Refund Processing">
        <p>
          Approved refunds will be processed to the original payment method within
          <span className="text-white"> 7–10 business days</span>, depending on your payment provider.
        </p>
      </Section>
    </PolicyLayout>
  );
}
